<template>
  <div class="sellCenter container storeBuyOrder">
    <!-- 过滤条件start -->
    <div ref="headerBtn" class="headerBtn">
      <!-- 顶部按钮start -->
      <div class="tabsBox">
        <el-tabs type="card" v-model="index" @tab-click="handleChangeType">
          <el-tab-pane label="全部订单" name="0"></el-tab-pane>
          <el-tab-pane label="待付款" name="1"> </el-tab-pane>
          <el-tab-pane label="待发货" name="2"> </el-tab-pane>
          <el-tab-pane label="已发货" name="3"> </el-tab-pane>
          <el-tab-pane label="待评价" name="4"> </el-tab-pane>
          <el-tab-pane label="退款" name="5"> </el-tab-pane>
          <el-tab-pane label="已完成" name="6"> </el-tab-pane>
        </el-tabs>
        <div class="afterBox"></div>
      </div>
      <!-- 顶部按钮end -->
    </div>
    <!-- 过滤条件end -->
    <div>
      <el-table
        :data="list"
        border
        highlight-current-row
        v-loading="loading"
        :height="tabHeight"
        ref="tableRef"
        @row-click="onRowClick"
        size="mini"
        @selection-change="handleSelectionChange"
        :style="{ 'background-color': 'transparent' }"
        :header-cell-style="{ 'background-color': '#f8f8f8' }"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="goodsDetailBox">
              <div v-for="(item, index) in scope.row.products" :key="index">
                <div class="goodsDetailItem">
                  <el-image
                    fit="cover"
                    class="goodsDetailItemImg textHover"
                    @click="() => checkImgAtTable(item)"
                    :data-src="getImageUrl(item.imgurl)"
                    :src="getImageUrl(item.imgurl)"
                  ></el-image>
                  <div class="goodsDetailItemText">
                    商品名称:{{ item.p_name }}
                  </div>
                  <div class="goodsDetailItemText">分类:{{ item.breed }}</div>
                  <div class="goodsDetailItemText">
                    单价:{{ item.price }}/{{ item.unit }}
                  </div>
                  <div class="goodsDetailItemText">
                    购买数量:{{ item.number }}{{ item.buyUnit }}
                  </div>
                  <div class="goodsDetailItemText" v-if="item.totalWeight">
                    总重:{{ item.totalWeight }}kg
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column width="250" align="center" label="操作">
          <div slot-scope="scope">
            <div
              v-if="
                scope.row &&
                getBtnGroup(scope.row) &&
                getBtnGroup(scope.row).length
              "
            >
              <el-button
                v-for="(item, index) in getBtnGroup(scope.row)"
                :key="index"
                class="_mini"
                @click="
                  () => {
                    item.onPress(scope.row,scope.$index);
                  }
                "
                type="info"
                size="mini"
                >{{ item.label }}</el-button
              >
            </div>
            <div v-else>-</div>
            <!-- <el-button class="_mini" type="info" size="mini">去评价</el-button>
            <el-button class="_mini" type="info" size="mini">申请退款</el-button> -->
          </div>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="订单类型"
          width="150"
        >
          <template slot-scope="scope">
            <div class="skyblue">
              {{ formateOrderType(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="buy_name"
          label="买家昵称"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="number"
          label="数量"
          width="100"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.products && scope.row.products[0]">
              {{
                scope.row.products.some((item) => {
                  if (item && item.breed) {
                    return item.breed.indexOf("白条") > -1;
                  }
                })
                  ? scope.row.totalWeight + scope.row.products[0].unit
                  : scope.row.number + (scope.row.products[0].unit || "件")
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          label="商品总价(元)"
          width="130"
        >
          <template slot-scope="scope">
            <div class="red">
              {{ formateTotalMoney(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="100"
          prop="order_id"
          label="订单编号"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="o_status"
          label="订单状态"
        >
          <template slot-scope="scope">
            <div :class="renderStatusClass(scope.row)">
              {{ formatteStatus(scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          label="下单时间"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.createTime | formateDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="take_name"
          label="收货人名称"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="phone"
          label="收货人电话"
        >
        </el-table-column>
      </el-table>
      <!-- 分页start -->
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="total,  prev, pager, next, jumper"
          :total="total || 0"
          :current-page="vueXPageIndex || pageIndex"
          :page-size="15"
        >
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>

    <!-- 改价start -->
    <el-dialog
      title="设置订单"
      :visible.sync="setPriceBoxVisible"
      width="500px"
      center
    >
      <div v-loading="formLoading" v-if="currentOrder" class="setPriceFormBox">
        <div class="formInfo" v-if="formInfoShow.value">
          <i class="el-icon-warning"></i>{{ formInfoShow.label }}
        </div>
        <el-form size="mini" label-width="80px" :model="setOrderForm">
          <el-form-item label="订单单价：">
            <el-input v-model="setOrderForm.price">
              <div slot="append">元/{{ currentOrder.products[0].unit }}</div>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="
              currentOrder.products[0].breed &&
              currentOrder.products[0].breed.indexOf('白条')
                ? '订单总量：'
                : '商品数量：'
            "
          >
            <el-input
              :disabled="
                currentOrder.products[0].unit == 'kg' ||
                currentOrder.products[0].unit == '吨'
                  ? false
                  : true
              "
              v-model="setOrderForm.weight"
            >
              <template slot="append">
                <div>
                  {{ currentOrder.products[0].unit || "件" }}
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="运费：">
            <el-input v-model="setOrderForm.trans_money">
              <template slot="prepend">
                <div>+</div>
              </template>
              <template slot="append">
                <div>元</div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="损耗：">
            <el-input v-model="setOrderForm.wastage_money">
              <template slot="prepend">
                <div>-</div>
              </template>
              <template slot="append">
                <div>元</div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="formText">
              {{
                (
                  setOrderForm.price * setOrderForm.weight +
                  setOrderForm.trans_money -
                  setOrderForm.wastage_money
                ).toFixed(2)
              }}(总价) = {{ setOrderForm.price }}(单价) *
              {{ setOrderForm.weight }}(总量) +{{
                setOrderForm.trans_money
              }}(运费)-{{ setOrderForm.wastage_money }}(损耗)
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="setPriceBoxVisible = false">取 消</el-button>
            <el-button type="primary" @click="setOrder">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 改价end -->

    <!-- 多商品改价start -->
    <el-dialog
      title="设置订单"
      :visible.sync="setPriceBoxVisible"
      width="500px"
      center
    >
      <div v-loading="formLoading" v-if="currentOrder" class="setPriceFormBox">
        <div class="formInfo" v-if="formInfoShow.value">
          <i class="el-icon-warning"></i>{{ formInfoShow.label }}
        </div>
        <el-form size="mini" label-width="80px" :model="setOrderForm">
          <el-form-item label="订单单价：">
            <el-input v-model="setOrderForm.price">
              <div slot="append">元/{{ currentOrder.products[0].unit }}</div>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="
              currentOrder.products[0].breed &&
              currentOrder.products[0].breed.indexOf('白条')
                ? '订单总量：'
                : '商品数量：'
            "
          >
            <el-input
              :disabled="
                currentOrder.products[0].unit == 'kg' ||
                currentOrder.products[0].unit == '吨'
                  ? false
                  : true
              "
              v-model="setOrderForm.weight"
            >
              <template slot="append">
                <div>
                  {{ currentOrder.products[0].unit || "件" }}
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="运费：">
            <el-input v-model="setOrderForm.trans_money">
              <template slot="prepend">
                <div>+</div>
              </template>
              <template slot="append">
                <div>元</div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="损耗：">
            <el-input v-model="setOrderForm.wastage_money">
              <template slot="prepend">
                <div>-</div>
              </template>
              <template slot="append">
                <div>元</div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="formText">
              {{
                (
                  setOrderForm.price * setOrderForm.weight +
                  setOrderForm.trans_money -
                  setOrderForm.wastage_money
                ).toFixed(2)
              }}(总价) = {{ setOrderForm.price }}(单价) *
              {{ setOrderForm.weight }}(总量) +{{
                setOrderForm.trans_money
              }}(运费)-{{ setOrderForm.wastage_money }}(损耗)
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="setPriceBoxVisible = false">取 消</el-button>
            <el-button type="primary" @click="setOrder">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 多商品改价end -->
    <!-- 发货start -->
    <el-dialog
      title="发货"
      :visible.sync="sendGoodsBoxVisible"
      width="500px"
      center
    >
      <div v-loading="formLoading" v-if="currentOrder" class="setPriceFormBox">
        <div class="formInfo" v-if="formInfoShow.value">
          <i class="el-icon-warning"></i>{{ formInfoShow.label }}
        </div>
        <el-form size="mini" label-width="80px" :model="sendGoods">
          <el-form-item label="物流公司：">
            <el-input v-model="sendGoods.logistics"> </el-input>
          </el-form-item>
          <el-form-item label="物流单号：">
            <el-input v-model="sendGoods.trackingNo"> </el-input>
          </el-form-item>
          <el-form-item>
            <div class="formText"></div>
          </el-form-item>
          <el-form-item>
            <el-button @click="setPriceBoxVisible = false">取 消</el-button>
            <el-button type="primary" @click="sendGoodsToUser">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 发货end -->
    <!-- 二维码start -->
    <el-dialog
      title="微信支付二维码"
      :visible.sync="ewmBoxVisible"
      width="500px"
      center
    >
      <div v-if="currentOrder" class="setPriceFormBox1">
        <span>买家扫描微信二维码即可支付该笔订单</span>
        <img class="ewmBox" :src="QRCodeUrl" alt="" />
        <span>订单编号:{{ currentOrder.order_id }}</span>
      </div>
    </el-dialog>
    <!-- 二维码end -->
  </div>
</template>

<script>
import {
  getImageUrl,
  getAreaByAreaId,
  deleteOrderUrl,
  queryManagerOrderListUrl,
  setOrderUrl,
  sendOrderUrl,
  transBilPc,
  baseUrl,
  createOderCode,
} from "@/api/api";
import { mapState, mapMutations } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      formInline: {
        user: "",
        region: "",
      },
      list: null,
      selectedList: null,
      loading: false,
      index: "",
      pageIndex: 1,
      total: 0,
      setPriceBoxVisible: false,
      currentOrder: null,
      setOrderForm: {
        price: "",
        weight: "",
        trans_money: "0",
        wastage_money: "0",
      },
      sendGoods: {
        logistics: "",
        trackingNo: "",
      },
      formInfoShow: {
        value: false,
        label: "",
      },
      formLoading: false,
      sendGoodsBoxVisible: false,
      QRCodeUrl: "",
      ewmBoxVisible: false,
      heightLightRowIndex: "",
      _currentRowIndex: "",
    };
  },
  created() {
    this.getImageUrl = getImageUrl;
  },
  mounted() {
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    this.pageIndex = this.vueXPageIndex || 1;
    this.index = this.vueXTypeIndex || '';
    setTimeout(() => {
      this.initData();
    }, 100);
  },
  computed: {
    ...mapState([
      "userInfo",
      "currentEditIndex",
      "vueXPageIndex",
      "vueXTypeIndex",
    ]),
    getOrderStatus() {
      // alert(this.index);
      switch (this.index) {
        case "0":
          return "";
        case "":
          return "";
        case undefined:
          return "";
        case 0:
          return "";
        case "1":
          return "1";
        case "2":
          return "2";
        case "3":
          return "3";
        case "4":
          return "4";
        case "5":
          return "12,13";
        case "6":
          return "5";
      }
    },
  },
  methods: {
    ...mapMutations([
      "savecurrentIndex",
      "savecurrentEditRow",
      "saveVueXPageIndex",
      "saveVueXTypeIndex",
    ]),
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.currentEditIndex) {
        return " current-row";
      }
      // return "";
      row.row_index = rowIndex;
      // if (rowIndex == this.currentRowIndex) {
      //   return "red";
      // }
    },
    downloaindPdf({ order_id, type }) {
      this.loading = true;
      let url = transBilPc;
      let data = {
        access_token: this.userInfo.access_token,
        order_id,
        type: 1,
      };

      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.data.resultCode == 1) {
            if (!res.data.data[0]) {
              this.$alert("暂无法获取该订单电子回单信息", "提示");
              return;
            }
            window.open(
              `${baseUrl}/transbill/order/${res.data.data[0]}`,
              "_blank"
            );
          } else {
            this.$alert(res.data.resultMsg, { center: true, showClose: false });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(JSON.stringify(err));
        });
    },
    sendProduct(item) {
      this.currentOrder = item;
      this.sendGoods = {
        logistics: item.address ? "公司配送" : "客户自提",
        trackingNo: item.address ? "公司配送" : "客户自提",
      };
      this.$nextTick(() => {
        this.sendGoodsBoxVisible = true;
      });
    },
    testSendGoodsValue() {
      let { logistics, trackingNo } = this.sendGoods;
      if (!logistics) {
        this.formInfoShow = {
          value: true,
          label: "请输入物流公司",
        };
        return false;
      }
      if (!trackingNo) {
        this.formInfoShow = {
          value: true,
          label: "请输入物流编号",
        };
        return false;
      }
      this.formInfoShow = {
        value: false,
        label: "",
      };
      return true;
    },
    sendGoodsToUser() {
      if (this.testSendGoodsValue()) {
        let { logistics, trackingNo } = this.sendGoods;

        this.formLoading = true;
        console.log("this.userInfo", this.userInfo);
        let data = {
          access_token: this.userInfo.access_token,
          userId: this.userInfo.userId,
          id: this.currentOrder.id,
          store_id: this.userInfo.storeId,
          logistics,
          trackingNo,
        };

        let param = new URLSearchParams();

        for (var k in data) {
          param.append(k, data[k]);
        }

        this.$axios({ method: "post", data: param, url: sendOrderUrl })
          .then((res) => {
            this.formLoading = false;
            if (res.data.resultCode == 1) {
              this.$message({
                message: "发货成功",
                type: "success",
              });
              this.sendGoodsBoxVisible = false;
              this.initData();
            } else {
              this.$alert(`${res.data.resultMsg}`, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.formLoading = false;
            this.$alert("请求异常:" + error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    onRowClick(row, event, column) {
      // this._currentRowIndex = row.row_index;
      // // console.log('row',1111)
      // alert(this._currentRowIndex)
      this.savecurrentIndex(null);
    },
    setOrder() {
      if (this.testValue()) {
        let { price, weight, trans_money, wastage_money } = this.setOrderForm;

        this.formLoading = true;
        console.log("this.userInfo", this.userInfo);
        let data = {
          access_token: this.userInfo.access_token,
          price,
          weight,
          orderId: this.currentOrder.id,
          store_id: this.userInfo.storeId,
          trans_money,
          wastage_money,
        };

        let param = new URLSearchParams();

        for (var k in data) {
          param.append(k, data[k]);
        }

        this.$axios({ method: "post", data: param, url: setOrderUrl })
          .then((res) => {
            this.formLoading = false;
            if (res.data.resultCode == 1) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.setPriceBoxVisible = false;
              this.initData();
              this.savecurrentIndex(this._currentRowIndex);

              console.log("currentOrder", this.currentOrder);
            } else {
              this.$alert(`${res.data.resultMsg}`, "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.formLoading = false;
            this.$alert("请求异常:" + error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    testValue() {
      let { price, weight, trans_money, wastage_money } = this.setOrderForm;

      if (isNaN(price)) {
        this.formInfoShow = {
          value: true,
          label: "单价格式有误",
        };
        return false;
      }

      if (!price) {
        this.formInfoShow = {
          value: true,
          label: "请填写单价",
        };
        return false;
      }

      if (
        this.currentOrder.products[0].unit == "kg" ||
        this.currentOrder.products[0].unit == "吨"
      ) {
        if (!weight) {
          this.formInfoShow = {
            value: true,
            label: "请填写总量",
          };
          return false;
        }

        if (isNaN(weight)) {
          this.formInfoShow = {
            value: true,
            label: "总量格式有误",
          };
          return false;
        }
      }

      if (isNaN(trans_money)) {
        this.formInfoShow = {
          value: true,
          label: "运费格式有误",
        };
        return false;
      }
      this.formInfoShow = {
        value: false,
        label: "",
      };
      return true;
    },
    checkImgAtTable(item) {
      console.log(item);
      this.$router.push({
        name: "goodsDetail",
        query: {
          goodsId: item.p_id,
          type: -1,
        },
      });
    },
    contactBuyer() {
      this.$alert("联系买家");
    },
    setPrice(item,index) {
      if (item.type == 11) {
        // Actions.push('setOrderWeight', { order: this.props.order })
        this.$alert("开市订单暂不支持改价");
      } else {
        //改价限制：1.如果订单里有两个品种的商品则不允许改价
        // alert(JSON.stringify(this.props.order))
        this.savecurrentEditRow(item);
        this.saveVueXPageIndex(this.pageIndex);
        this.saveVueXTypeIndex(this.index);
        // alert(this._currentRowIndex)
         this.savecurrentIndex(index);
        this.$router.push("mutlOrderSettingPrice");

        return;
        let isMutiulpartOrder = item.products.length > 1 ? true : false;

        if (isMutiulpartOrder) {
        } else {
          this.currentOrder = item;

          this.formInfoShow = {
            value: false,
            label: "",
          };
          console.log("item", item);
          this.setOrderForm = {
            price: item.products[0].price,
            weight:
              item.unit == "kg" || item.unit == "吨"
                ? item.totalWeight
                : item.number,
            trans_money: item.trans_money,
            wastage_money: item.wastage_money,
          };
          setTimeout(() => {
            this.setPriceBoxVisible = true;
          }, 100);
        }
      }
    },
    creatWxEwm(item) {
      let { access_token } = this.userInfo;

      let url = createOderCode;
      let data = {
        access_token: access_token,
        id: item.id,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          if (res.data.resultCode == 1) {
            console.log(res);
            this.currentOrder = item;
            this.QRCodeUrl = `${baseUrl}/qrcode/${res.data.data}`;
            this.ewmBoxVisible = true;
            console.log(this.QRCodeUrl);
          } else {
            this.$alert(res.data.resultMsg, {
              center: true,
              showClose: false,
            });
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err), {
            center: true,
            showClose: false,
          });
        });
    },
    getBtnGroup(item) {
      const { o_status, id, type, order_id, confirmTime, updateTime } = item;
      switch (o_status) {
        case 1: {
          if (type == 1) {
            //供需订单
            return [
              { label: "联系买家", onPress: this.contactBuyer },
              { label: "微信码", onPress: this.creatWxEwm },
            ];
          } else if (type == 11) {
            //肉类交易市场订单 (只能设置重量,后称重)
            return [
              { label: "联系买家", onPress: this.contactBuyer },
              { label: "核定重量", onPress: this.setPrice },
              { label: "微信码", onPress: this.creatWxEwm },
            ];
          } else {
            return [
              { label: "联系买家", onPress: this.contactBuyer },
              { label: "订单改价", onPress: this.setPrice },
              { label: "微信码", onPress: this.creatWxEwm },
            ];
          }
        }

        case 2:
          return [
            { label: "联系买家", onPress: this.contactBuyer },
            { label: "发货", onPress: this.sendProduct },
          ];
        case 3:
          return [
            {
              label: "延长收货",
              onPress: () => this.extendReceiving(id, confirmTime, updateTime),
            },
            { label: "联系买家", onPress: this.contactBuyer },
            { label: "查看物流", onPress: this.getLogistics },
          ];
        case 4:
          return item.payTime
            ? [
                { label: "联系买家", onPress: this.contactBuyer },
                {
                  label: "电子回单",
                  onPress: () => {
                    this.downloaindPdf(item);
                  },
                },
              ]
            : [{ label: "联系买家", onPress: this.contactBuyer }];

        case 5:
          return [
            item.payTime && {
              label: "电子回单",
              onPress: () => {
                this.downloaindPdf(item);
              },
            },
            // { label: '评价', onPress: this.comment }
          ];
        case 9:
          return [
            { label: "同意", onPress: this.respondRefund1(1, id) },
            { label: "拒绝", onPress: this.respondRefund1(2, id) },
            { label: "联系买家", onPress: this.contactBuyer },
          ];
        case 12:
          return [
            { label: "联系买家", onPress: this.contactBuyer },

            { label: "补款设置", onPress: this.setFillPrice },
            { label: "微信码", onPress: this.creatWxEwm },
          ];
        case 13:
          return [
            { label: "联系买家", onPress: this.contactBuyer },
            { label: "补款设置", onPress: this.setFillPrice },
            { label: "微信码", onPress: this.creatWxEwm },
          ];
      }
      return [];
    },
    formateOrderType({ type, group_id }) {
      if (group_id) {
        return "销售订单-联采";
      } else {
        if (type == 11) {
          return "销售订单-肉类交易市场";
        } else if (type == 14) {
          return "销售订单-兑换礼品订单";
        } else {
          return "销售订单";
        }
      }
    },
    formatteStatus({ o_status, fm_status }) {
      let text = "";
      switch (o_status) {
        case 1:
          text = "等待买家付款";
          break;
        case 2:
          text = "等待卖家发货";
          break;
        case 3:
          text = "卖家已发货";
          break;
        case 4:
          text = "等待买家评价";
          break;
        case 5:
          text = "订单已完成";
          break;
        case 6:
          text = "订单已取消";
          break;
        case 7:
          text = "订单已过期";
          break;
        case 8:
          text = "订单已删除";
          break;
        case 9:
          text = "已申请退款";
          break;
        case 10:
          text = "退款成功";
          break;
        case 11:
          text = "退款失败";
          break;
        case 12:
          text = "等待商家确认金额";
          break;
        case 13:
          text = "等待补款";
          break;
        case 14:
          text = "商家同意退款";
          break;
        case 15:
          text = "商家拒绝退款";
          break;
        default:
          break;
      }
      if (fm_status == 1 && status == 1) {
        text = "等待支付定金";
      }
      return text;
    },
    renderStatusClass({ o_status, fm_status }) {
      let className = "";
      switch (o_status) {
        case 1:
          className = "blue";
          break;
        case 2:
          className = "yellow";
          break;
        case 3:
          className = "skyblue";
          break;
        case 4:
          className = "green";
          break;
        case 5:
          className = "green";
          break;
        case 6:
          className = "gray";
          break;
        case 7:
          className = "gray";
          break;
        case 8:
          className = "gray";
          break;
        case 9:
          className = "pink";
          break;
        case 10:
          className = "green";
          break;
        case 11:
          className = "red";
          break;
        case 12:
          className = "blue";
          break;
        case 13:
          className = "blue";
          break;
        case 14:
          className = "blue";
          break;
        case 15:
          className = "red";
          break;
        default:
          break;
      }
      if (fm_status == 1 && status == 1) {
        className = "等待支付定金";
      }
      return className;
    },
    toPay(row) {
      let {
        id,
        order_id,
        totalMoney,
        prepayment,
        type,
        fm_status,
        pay_flag,
        store_name,
        store_id,
      } = row;
      console.log("this.currentOrder");
      console.log(this.currentOrder);
      this.$router.push({
        name: "payPage",
        query: {
          id,
          order_id,
          totalMoney,
          prepayment,
          type,
          fm_status,
          pay_flag,
          store_name,
          store_id,
        },
      });
    },
    getLogistics() {
      this.$alert("暂未开放相关功能", "提示");
    },
    handleCurrentChange(e) {
      this.saveVueXPageIndex("");
      this.savecurrentIndex(null);
      // alert(1)
      console.log(e);
      this.pageIndex = e;
      setTimeout(() => {
        this.initData();
      });
    },
    formateTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    },

    handleChangeType(e) {
      // alert(11)
      console.log(e.index);
      this.index = e.index;
      this.pageIndex = 1
      this.saveVueXPageIndex("");
      this.saveVueXTypeIndex("");
      this.savecurrentIndex(null);
      setTimeout(() => {
        this.initData();
      });
    },

    deleteOrder(row) {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        ids: row.id,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: deleteOrderUrl })
        .then((res) => {
          that.loading = false;
          if (res.data.resultCode == 1) {
            that.$message({
              message: "删除成功",
              type: "success",
            });
            that.initData();
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    handleSelectionChange(e) {
      this.selectedList = e;
    },
    processData({ p_list = [], o_list = [], m_list = [] }) {
      return o_list.map((order) => ({
        ...order,
        products: p_list
          .filter((product) => product.orderId === order.id)
          .map((product) => ({
            ...product,
            items: m_list.filter((item) => item.opId === product.id),
          })),
      }));
    },
    initData() {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        store_id: this.userInfo.storeId,
        o_status: this.getOrderStatus,
        // pageNum: pageIndex,
        pageIndex: this.pageIndex - 1,
        pageSize: 15,
        type: 1, //1作为卖家的,2作为买家的
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({
        method: "post",
        data: param,
        url: queryManagerOrderListUrl,
      })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            let data1 = res.data.data || {};
            // alert(1)
            data1 = that.processData(data1 || {}).filter((item) => {
              return item.type != 9;
            });
            that.total = res.data.count || 0;
            that.list = JSON.parse(JSON.stringify(data1 || []));
            console.log("that.list", that.list);
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      });
    },
  },
};
</script>

<style scoped lang='less'>
.headerBtn {
  margin-bottom: 10px;
  // background-color: red;
}
.container {
  margin: 10px;
}
.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}

.afterBox {
  border-bottom: 1px solid #009e96;
  display: inline;
  width: 200px;
  position: relative;
  // left:-2px;
  z-index: 10;
  background-color: #f6f6f6;
}
.tabsBox {
  display: flex;
  flex-direction: row;
}
.goodsDetailItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ecf5ff;
  margin-bottom: 10px;
  padding: 10px;
}
.goodsDetailItemImg {
  width: 60px;
  height: 60px;
}
.goodsDetailItemText {
  margin-left: 40px;
  font-size: 12px;
  color: #545454;
}
.goodsDetailBox {
}
.setPriceFormBox {
  max-width: 350px;
  text-align: center;
  position: relative;
  margin-top: 25px;
}
.setPriceFormBox1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.formInfo {
  display: inline-block;
  width: 200px;
  height: 25px;
  background-color: rgba(0, 0, 0, 0.1) !important;
  color: #009688;
  position: absolute;
  top: -35px;
  left: 80px;
  text-align: left;
  line-height: 25px;
  border-radius: 5px;
  padding: 3px;
  padding-left: 15px;
  font-size: 13px;
}
.el-icon-warning {
  margin-right: 5px;
}
.formText {
  color: purple;
  font-size: 12px;
  height: 20px;
  width: 300px;
}
.ewmBox {
  width: 200px;
  height: 200px;
}
.currentRow {
  background-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/StoreSellOrder.vue